import { default as i18n } from 'i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';
import { i18nextPlugin } from 'translation-check';

if (process.env.NODE_ENV !== 'production') {
    i18n.use(i18nextPlugin);
}

i18n.use(
    resourcesToBackend(async (lang: string, ns: string) => {
        const result = await fetch(`/locales/${lang}/${ns}.json`);
        if (!result.ok) {
            return null;
        }

        return await result.json();
    })
)
    .use(initReactI18next)
    .init({
        supportedLngs: ['en', 'es'],
        partialBundledLanguages: true,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
        ns: ['lilly', 'pds', 'phx-lib', 'pwa', 'maintenance'],
        defaultNS: 'lilly',
        returnEmptyString: false,
    });

export default i18n;
